import { Component, OnInit, OnDestroy } from '@angular/core';
import { UsersService } from '../users/users.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-redirect-home',
  templateUrl: './redirect-home.component.html',
  styleUrls: ['./redirect-home.component.scss']
})
export class RedirectHomeComponent implements OnInit, OnDestroy {

  me$;
  meSubscribe;

  constructor(
    private usersService: UsersService,
    private router: Router,
  ) {
    this.me$ = this.usersService.me$;
  }

  ngOnInit() {
    this.meSubscribe = this.me$.subscribe((me: any) => {
      console.log('RedirectHomeComponent', me);
      if (me.role === 'ROLE_SUPER_ADMIN' || me.role === 'ROLE_ADMIN' || me.role === 'ROLE_COORDINATOR') {
        this.router.navigate(['/dashboard']);
      } else {
        this.router.navigate(['/calendar']);
      }
    });
  }

  ngOnDestroy() {
    this.meSubscribe.unsubscribe();
  }
}
